import React from 'react';
import '../App.css';

function Home(props) {
  const footerText= `This website was made with React.js, the usual ingredients and <3 by Berniris Coleman.`

  return (


  <div>
    <div className="container">
    <div className="flex">
    <div className="infobox-1">
    <h1>Welcome</h1>
    <p>Thanks for visiting my project page! If the title didn't clue you in this is a site dedicated to showcasing my journey creating a new website every day for 30 days. Click the about me link in the menu bar for more information about why I'm even doing this. You may direct any grievances concerning the pepto bismol pink (and other inquiries) to berniriscoleman@gmail.com or click the contact link, please & thank You :)
    </p>
    </div>
    <div className="infobox-2">
    <h1>Projects</h1>
    <div class="home-proj-info">
    <h2>Day 1 - Jan 27</h2>
    <p class="proj-info-main">Today's prompt is to create a portfolio site which I already have, so I decided to make a sub portfolio to store all the projects I create throughout the course of this challenge. This site was made with React.js and deployed with Google Firebase.</p>
    <a href="https://in30-cb47d.firebaseapp.com/" target="_new"><img src="https://i.imgur.com/t6B2Uy6.png" class="preview" alt="portfolio_website"></img></a>
    </div>
    <div class="home-proj-info">
    <h2>Day 2 - Jan 28</h2>
    <p class="proj-info-main">Today's task is to create an information site for a favorite movie. Anyone who knows me knows I LOVE horror films! I also really enjoy trying recreating websites without looking at the HTML & CSS. Here's the official site for the upcoming Jordan Peele horror film, <a href="https://www.usmovie.com" target="_new">Us</a> and below a link to my attempt at recreating it. </p>
    <a href="http://bite-sized-face.surge.sh/" target="_new"><img src="https://i.imgur.com/ce0RGub.jpg" class="preview" alt="movie_website"></img></a>
    </div>
    </div>
    </div>
    </div>
</div>
    );
  }
export default Home;